
<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix" style="min-height: 500px">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>申報年度</td>
                  <td colspan="3">
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                    <label style="color: red">請確認欲查詢的申報年度</label>
                  </td>
                </tr>
                <tr>
                  <td>服務機關</td>
                  <td colspan="3">
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum &&
                        loginInfo.govCode != '355010000I' &&
                        loginInfo.govCode != 'A11100000F'
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum &&
                        loginInfo.govCode != '355010000I' &&
                        loginInfo.govCode != 'A11100000F'
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum &&
                        loginInfo.govCode != '355010000I' &&
                        loginInfo.govCode != 'A11100000F'
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關：</td>
                  <td colspan="3">
                    <select
                      v-model="form.govCode1"
                      style="min-width: 200px"
                      @change="GovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode2"
                      style="min-width: 200px"
                      @change="GovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode3"
                      style="min-width: 200px"
                      @change="GovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.govCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.idn" />
                  </td>
                  <td>姓名：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td>申報種類</td>
                  <td colspan="3">
                    <select v-model="form.dtype">
                      <option value=""></option>
                      <option value="1">定期申報</option>
                      <option value="2">就到職申報</option>
                      <option value="3">代理及兼任申報</option>
                      <option value="4">解除代理及解除兼任申報</option>
                      <option value="5">卸（離）職申報</option>
                      <option value="6">不須申報</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          @click="
                            () => {
                              this.form.currentpage = 1;
                              this.form.pagesize = 10;
                              this.doQuery();
                            }
                          "
                          value="查詢"
                        />
                        <input
                          type="button"
                          class="btn"
                          value="新增"
                          @click="btnAdd()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 頁籤結束 -->
      </div>
    </div>
    <!-- 查詢結果開始-->
    <div class="information" v-if="grid">
      <table width="100%" v-if="grid">
        <tbody>
          <tr>
            <td>
              <font color="#FF0000"
                >注意：此功能為批次方式執行，每天更新的時間為：AM 00:00</font
              >
            </td>
            <td align="right" v-if="grid.paginaiton">
              <input
                type="button"
                value="<<"
                class="btn"
                style="height: 28px"
                @click="form.currentpage = grid.paginaiton.pageNo - 1"
                v-show="grid.paginaiton.pageNo > 1"
              />
              <span
                v-for="(data, index) in grid.paginaiton.pages"
                :key="index"
                style="cursor: pointer"
                :style="
                  grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                "
                @click="form.currentpage = parseInt(data)"
              >
                {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
              </span>
              <input
                type="button"
                class="btn"
                value=">>"
                style="height: 28px"
                v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                @click="form.currentpage = grid.paginaiton.pageNo + 1"
              />
              ［每頁<input
                type="text"
                v-model.number.lazy="form.pagesize"
                size="2"
                maxlength="4"
              />

              <input type="button" class="btn" value="筆" />，第<input
                type="text"
                v-model.number.lazy="form.currentpage"
                size="2"
                maxlength="4"
              />
              <input type="button" class="btn" value="頁" />，共
              {{ grid.paginaiton.totalPage }} 頁
              {{ grid.paginaiton.totalCount }} 筆］
            </td>
          </tr>
        </tbody>
      </table>
      <div class="active">
        <div class="table_scroll2">
          <table width="1060" class="itable">
            <thead>
              <tr>
                <th>操作</th>
                <th>編號</th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('DTYPE', Sort);
                      }
                    "
                    >申報<br />種類</u
                  >
                </th>
                <th style="min-width: 80px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('NAME', Sort);
                      }
                    "
                    >姓名</u
                  >
                </th>
                <th>身分證<br />統一編號</th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('goV_NAME', Sort);
                      }
                    "
                    >服務 <br />機關</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('joB_GOV_CODE', Sort);
                      }
                    "
                    >受理申<br />報機關</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('title', Sort);
                      }
                    "
                    >職稱</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('arrivE_DATE', Sort);
                      }
                    "
                    >到職日</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('leavE_DATE', Sort);
                      }
                    "
                    >離職日</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('tel', Sort);
                      }
                    "
                    >聯絡<br />電話</u
                  >
                </th>
                <th>申報<br />日期</th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('datetimE', Sort);
                      }
                    "
                    >上傳<br />日期</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('overdue', Sort);
                      }
                    "
                    >逾期<br />
                    註記</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('sT_DATE', Sort);
                      }
                    "
                    >申報<br />
                    起日</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('enD_DATE', Sort);
                      }
                    "
                    >申報<br />
                    迄日</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('note', Sort);
                      }
                    "
                    >備註</u
                  >
                </th>
                <th>狀態</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in grid.gridDatas" :key="index">
                <td width="1%" align="center">
                  <input
                    type="button"
                    class="btn"
                    value="編"
                    @click="btnEdit(data)"
                    :disabled="
                      data.syear == new Date().getFullYear() - 1911 ||
                      !data.pkno
                    "
                  />
                </td>
                <td>{{ index + 1 }}</td>
                <td>{{ data.dtypE_NAME }}</td>
                <td>{{ data.name }}</td>
                <td>
                  <input
                    type="button"
                    class="btn"
                    :value="data.idn"
                    @click="btnA101Detail(data)"
                  />
                </td>
                <td>{{ data.joB_GOV_CODE_NAME }}</td>
                <td>{{ data.goV_NAME }}</td>
                <td>{{ data.title }}</td>
                <td>{{ data.arrivE_DATE_STR }}</td>
                <td>{{ data.leavE_DATE_STR }}</td>
                <td>{{ data.tel }}</td>
                <td>{{ data.sdate }}</td>
                <td>{{ data.datetimE_STR }}</td>
                <!--20210701 sdate => datetimE_STR-->
                <td>{{ data.overdue }}</td>
                <td>{{ data.sT_DATE_STR }}</td>
                <td>{{ data.enD_DATE_STR }}</td>
                <td>{{ data.note }}</td>
                <td>
                  <font
                    v-if="data.syear == new Date().getFullYear() - 1911"
                    color="#FF0000"
                    >今年度資料為自動產生.資料尚無法修改</font
                  >
                </td>
              </tr>
              <tr v-if="!(grid && grid.gridDatas && grid.gridDatas.length > 0)">
                <td style="text-align: center" colspan="17">查無資料</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="information"
        style="margin-top: 30px"
        v-if="grid && grid.countDatas && grid.countDatas.length > 0"
      >
        <table width="100%">
          <tbody>
            <tr>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th v-for="(data, index) in grid.countDatas" :key="index">
                    {{ data.dtypE_NAME }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-for="(data, index) in grid.countDatas" :key="index">
                    應申報人數： {{ data.alL_COUNT }}
                  </td>
                </tr>
                <tr>
                  <td v-for="(data, index) in grid.countDatas" :key="index">
                    已申報人數： {{ data.oK_COUNT }}
                  </td>
                </tr>
                <tr>
                  <td v-for="(data, index) in grid.countDatas" :key="index">
                    未申報人數： {{ data.yeT_COUNT }}
                  </td>
                </tr>
                <tr>
                  <td v-for="(data, index) in grid.countDatas" :key="index">
                    申報率： {{ data.applY_RATE }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </div>

    <DetailModal
      v-model="DetailModal.show"
      :title="DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>申報年度</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.syear"
                    :disabled="DetailModal.ModifyType == 'U'"
                  >
                    <option
                      v-for="(data, index) in DetailModal.dropDownList.syears"
                      :key="index"
                      :value="data"
                    >
                      {{ data }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>服務機關</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.jobGovCode1"
                    style="min-width: 200px"
                    @change="DetailModalJobGovCode1Change()"
                    :disabled="
                      (loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum) ||
                      DetailModal.ModifyType == 'U'
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .jobGovCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.jobGovCode2"
                    style="min-width: 200px"
                    @change="DetailModalJobGovCode2Change()"
                    :disabled="
                      (loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum) ||
                      DetailModal.ModifyType == 'U'
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .jobGovCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.jobGovCode3"
                    style="min-width: 200px"
                    @change="DetailModalJobGovCode3Change()"
                    :disabled="
                      (loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum) ||
                      DetailModal.ModifyType == 'U'
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .jobGovCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.jobGovCode4"
                    style="min-width: 200px"
                    :disabled="
                      (loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum) ||
                      DetailModal.ModifyType == 'U'
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .jobGovCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.govCode1"
                    style="min-width: 200px"
                    @change="DetailModalGovCode1Change()"
                    disabled
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.govCode2"
                    style="min-width: 200px"
                    @change="DetailModalGovCode2Change()"
                    disabled
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.govCode3"
                    style="min-width: 200px"
                    @change="DetailModalGovCode3Change()"
                    disabled
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.govCode4"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>身分證統一編號</td>
                <td>
                  <input
                    type="text"
                    maxlength="10"
                    v-model="DetailModal.form.idn"
                    :disabled="DetailModal.ModifyType == 'U'"
                  />
                </td>

                <td>姓名</td>
                <td>
                  <input
                    type="text"
                    maxlength="10"
                    v-model="DetailModal.form.name"
                    :disabled="DetailModal.ModifyType == 'U'"
                  />
                </td>
              </tr>
              <tr>
                <td>單位及職稱</td>
                <td>
                  <input
                    type="text"
                    v-model="DetailModal.form.title"
                    :disabled="DetailModal.ModifyType == 'U'"
                  />
                </td>
                <td>階級</td>
                <td>
                  <select
                    v-model="DetailModal.form.rank"
                    :disabled="
                      DetailModal.form.govCode1 != '305000000C' ||
                      DetailModal.ModifyType == 'U'
                    "
                  >
                    <option value="">無</option>
                    <option value="1">上將</option>
                    <option value="2">中將</option>
                    <option value="3">少將</option>
                    <option value="4">上校</option>
                    <option value="5">中校</option>
                    <option value="6">少校</option>
                    <option value="7">上尉</option>
                    <option value="8">中尉</option>
                    <option value="9">少尉</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>聯絡電話</td>
                <td colspan="3">
                  <input
                    type="text"
                    v-model="DetailModal.form.tel"
                    size="20"
                    maxlength="20"
                    :disabled="DetailModal.ModifyType == 'U'"
                  />
                </td>
              </tr>
              <tr>
                <td>現職狀況</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.leave"
                    style="min-width: 480px"
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList.onJobs"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>到職日</td>
                <td>
                  <DatePicker
                    v-model="DetailModal.form.arriveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
                <td>去職日</td>
                <td>
                  <DatePicker
                    v-model="DetailModal.form.leaveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="false"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
              </tr>
              <tr>
                <td>申報種類</td>
                <td colspan="3">
                  <select v-model="DetailModal.form.dtype">
                    <option value=""></option>
                    <option value="1">定期申報</option>
                    <option value="2">就到職申報</option>
                    <option value="3">代理及兼任申報</option>
                    <option value="4">解除代理及解除兼任申報</option>
                    <option value="5">卸（離）職申報</option>
                    <option value="6">不須申報</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>申報起始日</td>
                <td>
                  <DatePicker
                    v-model="DetailModal.form.sT_DATE"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
                <td>申報結束日</td>
                <td>
                  <DatePicker
                    v-model="DetailModal.form.enD_DATE"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
              </tr>
              <tr>
                <td>上傳日</td>
                <td>
                  <DatePicker
                    v-model="DetailModal.form.datetime"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
                <td>逾期註記</td>
                <td>
                  <p>
                    <label>
                      <input
                        type="radio"
                        value="Y"
                        v-model="DetailModal.form.lOVERDUE"
                      />
                      Y</label
                    >
                    <label>
                      <input
                        type="radio"
                        value="N"
                        v-model="DetailModal.form.lOVERDUE"
                      />
                      N</label
                    >
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td>備註</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      size="80"
                      maxlength="80"
                      v-model="DetailModal.form.note"
                    />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="B105_DetailEditSaveAlert()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="DetailModalBtnClear()"
                        :disabled="DetailModal.ModifyType == 'U'"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </DetailModal>

    <A101DetailModal
      v-model="A101DetailModal.show"
      :title="A101DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>服務機關</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.jobGovCode1"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.jobGovCode2"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.jobGovCode3"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.jobGovCode4"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.govCode1"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.govCode2"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.govCode3"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.govCode4"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>身分證統一編號/居留證號</td>
                <td>
                  <input
                    type="text"
                    maxlength="20"
                    v-model="A101DetailModal.form.idn"
                    disabled
                  />
                </td>
                <td>姓名</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.name"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>生日</td>
                <td colspan="3">
                  <DatePicker
                    v-model="A101DetailModal.form.birthday"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>單位及職稱</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.title"
                    disabled
                  />
                </td>
                <td>階級</td>
                <td>
                  <select v-model="A101DetailModal.form.rank" disabled>
                    <option value="">無</option>
                    <option value="1">上將</option>
                    <option value="2">中將</option>
                    <option value="3">少將</option>
                    <option value="4">上校</option>
                    <option value="5">中校</option>
                    <option value="6">少校</option>
                    <option value="7">上尉</option>
                    <option value="8">中尉</option>
                    <option value="9">少尉</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>聯絡電話</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.tel"
                    size="20"
                    maxlength="20"
                    disabled
                  />
                </td>
                <td>E-Mail</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.email"
                    size="20"
                    maxlength="40"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>到職日</td>
                <td>
                  <DatePicker
                    v-model="A101DetailModal.form.arriveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    disabled
                  />
                </td>
                <td>去職日</td>
                <td>
                  <DatePicker
                    v-model="A101DetailModal.form.leaveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>現職狀況</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.leave"
                    style="min-width: 480px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .onJobs"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>應申報身分資格</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.status"
                    style="max-width: 1000px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .OnDeclare"
                      :value="item.mcode"
                      :key="index"
                    >
                      {{ item.mvalue }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>備註</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model="A101DetailModal.form.leave_Reason"
                      size="80"
                      maxlength="80"
                      disabled
                    />
                    <br />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </A101DetailModal>

    <PdisFooter />

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>

    <AlertSave v-model="AlertSave.show" :title="AlertSave.title">
      <div style="text-align: center">
        <p>
          修改C功能資料將影響當年度抽籤、實審等相關系統功能，亦會影響D功能報表正確性，如有修改申報種類、申報起始日、申報結束日、上傳日，請務必確認資料修改之正確性，如有疑問，請與客服專線聯絡。是否確定完成修改？
        </p>
        <div>
          <button class="btn" @click="DetailModalBtnSave()">確定</button>
          <button class="btn" @click="AlertSave.show = false">取消</button>
        </div>
      </div>
    </AlertSave>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenu } from "@/config/util.js";
import { ChkIDorRCNumber, getMenuIndex } from "@/config/util.js";
import WaitEnd from "@/components/Common/WaitEnd.vue";
import {
  SearchGovCode,
  SearchGridOnJob,
  SearchRGovCode,
  SearchGridOnDeclare,
  A101_DetailInit,
  B105_SearchGrid,
  B105_ReSearchGrid,
  B105_CountTotal,
  B105_Detail,
  B105_DetailAddSave,
  B105_DetailEditSave,
} from "@/service/api.js";
export default {
  name: "B105",
  data: function () {
    return {
      pageData: {
        MenuIndex: 2,
        MenuName: "",
        PrgName: "B105",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      Numm: 0,
      form: {
        syear: String(new Date().getFullYear() - 1911),
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "0",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        dtype: "",
        currentpage: 1,
        pagesize: 10,
      },
      dropDownList: {
        syears: [],
        govCode1s: [],
        govCode2s: [],
        govCode3s: [],
        govCode4s: [],
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
      },
      grid: {},
      DetailModal: {
        show: false,
        title: "",
        ModifyType: "I", //I,U
        PreData: {},
        form: {
          syear: String(new Date().getFullYear() - 1911),
          jobGovCode1: "",
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          govCode1: "",
          govCode2: "",
          govCode3: "",
          govCode4: "",
          idn: "",
          name: "",
          title: "",
          rank: "",
          tel: "",
          leave: "",
          arriveDate: "",
          leaveDate: "",
          dtype: "",
          sT_DATE: "",
          enD_DATE: "",
          sdate: "",
          datetime: "",
          lOVERDUE: "N",
          note: "",
        },
        dropDownList: {
          syears: [],
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
          govCode1s: [],
          govCode2s: [],
          govCode3s: [],
          govCode4s: [],
          //在職狀態
          onJobs: [],
        },
      },
      A101DetailModal: {
        show: false,
        title: "A101申報人基本資料",
        form: {
          govCode1: "",
          govCode2: "",
          govCode3: "",
          govCode4: "",
          jobGovCode1: "",
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          idn: "",
          name: "",
          birthday: "",
          title: "",
          rank: "",
          tel: "",
          email: "",
          arriveDate: "",
          leaveDate: "",
          //現職狀況
          leave: "",
          //應申報身分資格
          status: "",
          //備註
          leave_Reason: "",
        },
        modifyType: "", //"I,U"
        dropDownList: {
          govCode1s: [],
          govCode2s: [],
          govCode3s: [],
          govCode4s: [],
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
          OnDeclare: [],
          onJobs: [],
        },
        PreData: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: "",
        BtnConfirm: function () {
          this.show = false;
        },
      },
      AlertSave: {
        show: false,
        title: "",
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
    AlertSave: VueModal,
    DetailModal: VueModal,
    A101DetailModal: VueModal,
    DatePicker: VueDatepicker,
  },
  methods: {
    getSyearDropDownList: function () {
      let syears = [];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //取得服務機關第一層類別
    getSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得服務機關第二層類別
    getSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得服務機關第三層類別
    getSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得服務機關第四層類別
    getSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        if (self.loginInfo.govCode == "355010000I") {
          self.dropDownList.jobGovCode2s = rData.returnObject.filter(
            (x) => x.value == "355010000I" || x.value == "355020000I"
          );
        } else if (self.loginInfo.govCode == "A11100000F") {
          self.dropDownList.jobGovCode2s = rData.returnObject.filter(
            (x) => x.value == "A11100000F" || x.value == "A11000600F"
          );
        } else {
          self.dropDownList.jobGovCode2s = rData.returnObject;
        }
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //DetailModal 取得年度下拉
    DetailModalGetSyearDropDownList: function () {
      let syears = [];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //DetailModal 取得受理申報機關第一層類別
    DetailModalGetSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //DetailModal 取得受理申報機關第二層類別
    DetailModalGetSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //DetailModal 取得受理申報機關第三層類別
    DetailModalGetSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //DetailModal 取得受理申報機關第四層類別
    DetailModalGetSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //DetailModal 取得受理申報機關第一層類別
    DetailModalGetSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //DetailModal 取得受理申報機關第二層類別
    DetailModalGetSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        if (self.loginInfo.govCode == "355010000I") {
          self.DetailModal.dropDownList.jobGovCode2s =
            rData.returnObject.filter(
              (x) => x.value == "355010000I" || x.value == "355020000I"
            );
        } else if (self.loginInfo.govCode == "A11100000F") {
          self.DetailModal.dropDownList.jobGovCode2s =
            rData.returnObject.filter(
              (x) => x.value == "A11100000F" || x.value == "A11000600F"
            );
        } else {
          self.DetailModal.dropDownList.jobGovCode2s = rData.returnObject;
        }
      });
    },
    //DetailModal 取得受理申報機關第三層類別
    DetailModalGetSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //DetailModal 取得受理申報機關第四層類別
    DetailModalGetSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //取得在職狀態
    DetailModalGetOnJob: function () {
      const self = this;
      SearchGridOnJob({}).then((rData) => {
        self.DetailModal.dropDownList.onJobs = [{ value: "", text: "" }].concat(
          rData.returnObject
        );
      });
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
      //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      debugger;
      let postData = {
        idn: self.form.idn,
        name: self.form.name,
        dtype: self.form.dtype,
        syear: self.form.syear,
        goV_CODE: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        goV_CODE_STR:
          self.form.govCode1 +
          "," +
          self.form.govCode2 +
          "," +
          self.form.govCode3 +
          "," +
          self.form.govCode4,
        GOVCHECK: parseInt(self.form.govCheck),
        joB_GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        joB_GOV_CODE_STR:
          self.form.jobGovCode1 +
          "," +
          self.form.jobGovCode2 +
          "," +
          self.form.jobGovCode3 +
          "," +
          self.form.jobGovCode4,
        jobGovCheck: parseInt(self.form.jobGovCheck),
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        currentpage: self.form.currentpage,
        pagesize: self.form.pagesize,
      };
      B105_SearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
        B105_CountTotal({
          idn: self.form.idn,
          name: self.form.name,
          dtype: "",
          syear: self.form.syear,
          goV_CODE: self.form.govCode4
            ? self.form.govCode4
            : self.form.govCode3
            ? self.form.govCode3
            : self.form.govCode2
            ? self.form.govCode2
            : self.form.govCode1
            ? self.form.govCode1
            : "",
          goV_CODE_STR:
            self.form.govCode1 +
            "," +
            self.form.govCode2 +
            "," +
            self.form.govCode3 +
            "," +
            self.form.govCode4,
          GOVCHECK: parseInt(self.form.govCheck),
          joB_GOV_CODE: self.form.jobGovCode4
            ? self.form.jobGovCode4
            : self.form.jobGovCode3
            ? self.form.jobGovCode3
            : self.form.jobGovCode2
            ? self.form.jobGovCode2
            : self.form.jobGovCode1
            ? self.form.jobGovCode1
            : "",
          joB_GOV_CODE_STR:
            self.form.jobGovCode1 +
            "," +
            self.form.jobGovCode2 +
            "," +
            self.form.jobGovCode3 +
            "," +
            self.form.jobGovCode4,
          jobGovCheck: parseInt(self.form.jobGovCheck),
        }).then((rData) => {
          self.grid.countDatas = rData.returnObject.countDatas;
        });
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "IDN";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        idn: self.form.idn,
        name: self.form.name,
        dtype: self.form.dtype,
        syear: self.form.syear,
        goV_CODE: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        goV_CODE_STR:
          self.form.govCode1 +
          "," +
          self.form.govCode2 +
          "," +
          self.form.govCode3 +
          "," +
          self.form.govCode4,
        GOVCHECK: parseInt(self.form.govCheck),
        joB_GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        joB_GOV_CODE_STR:
          self.form.jobGovCode1 +
          "," +
          self.form.jobGovCode2 +
          "," +
          self.form.jobGovCode3 +
          "," +
          self.form.jobGovCode4,
        jobGovCheck: parseInt(self.form.jobGovCheck),
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        currentpage: self.form.currentpage,
        pagesize: self.form.pagesize,
        SORT: self.Sort,
        ORDER: self.Order,
      };
      B105_ReSearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
        B105_CountTotal({
          idn: self.form.idn,
          name: self.form.name,
          dtype: "",
          syear: self.form.syear,
          goV_CODE: self.form.govCode4
            ? self.form.govCode4
            : self.form.govCode3
            ? self.form.govCode3
            : self.form.govCode2
            ? self.form.govCode2
            : self.form.govCode1
            ? self.form.govCode1
            : "",
          goV_CODE_STR:
            self.form.govCode1 +
            "," +
            self.form.govCode2 +
            "," +
            self.form.govCode3 +
            "," +
            self.form.govCode4,
          GOVCHECK: parseInt(self.form.govCheck),
          joB_GOV_CODE: self.form.jobGovCode4
            ? self.form.jobGovCode4
            : self.form.jobGovCode3
            ? self.form.jobGovCode3
            : self.form.jobGovCode2
            ? self.form.jobGovCode2
            : self.form.jobGovCode1
            ? self.form.jobGovCode1
            : "",
          joB_GOV_CODE_STR:
            self.form.jobGovCode1 +
            "," +
            self.form.jobGovCode2 +
            "," +
            self.form.jobGovCode3 +
            "," +
            self.form.jobGovCode4,
          jobGovCheck: parseInt(self.form.jobGovCheck),
        }).then((rData) => {
          self.grid.countDatas = rData.returnObject.countDatas;
        });
      });
    },
    //第一頁 重填
    btnClear: function () {
      const self = this;
      self.form = {
        syear: String(new Date().getFullYear() - 1911),
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "0",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        dtype: "",
        currentpage: 1,
        pagesize: 10,
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
      self.GovCodeInit(self.form);
      self.getSearchGovCode1();
    },
    //第一頁 新增
    btnAdd: function () {
      const self = this;
      self.DetailModal.show = true;
      self.DetailModal.title = self.pageData.MenuName + "-新增基本資料";
      self.DetailModal.ModifyType = "I";
      self.DetailModalInit();
      self.Numm = 0; //新增需初始化
    },
    //第一頁 編
    btnEdit: function (data) {
      const self = this;
      self.DetailModal.show = true;
      self.DetailModal.title = self.pageData.MenuName + "-編輯基本資料";
      self.DetailModal.ModifyType = "U";
      self.DetailModal.PreData = data;
      self.DetailModalInittoEdit();
    },
    //第二頁 init
    DetailModalInit: function () {
      const self = this;
      self.DetailModalBtnClear();

      self.DetailModalGetSearchJobGovCode1();
      self.DetailModalGetSearchJobGovCode2(self.DetailModal.form.jobGovCode1);

      self.DetailModalGetSearchGovCode1();
      self.DetailModalGetSearchGovCode2(self.DetailModal.form.govCode1);

      self.DetailModal.dropDownList.syears =
        self.DetailModalGetSyearDropDownList();
      self.DetailModalGetOnJob();
    },
    //第二頁 init in 編輯
    DetailModalInittoEdit: function () {
      const self = this;
      self.DetailModalBtnClear();
      WaitEnd.methods.send(
        () => {
          self.B105_Detail();
        },
        () => {
          // self.DetailModalGetSearchJobGovCode1();
          // self.DetailModalGetSearchGovCode1();
          WaitEnd.methods.send(
            () => {
              self.DetailModalGetSearchGovCode1();
            },
            () => {
              WaitEnd.methods.send(
                () => {
                  if (self.DetailModal.form.govCode1 != "")
                    self.DetailModalGetSearchGovCode2(
                      self.DetailModal.form.govCode1
                    );
                },
                () => {
                  WaitEnd.methods.send(
                    () => {
                      if (self.DetailModal.form.govCode2 != "")
                        self.DetailModalGetSearchGovCode3(
                          self.DetailModal.form.govCode2
                        );
                    },
                    () => {
                      if (self.DetailModal.form.govCode3 != "")
                        self.DetailModalGetSearchGovCode4(
                          self.DetailModal.form.govCode3
                        );
                    }
                  );
                }
              );
            }
          );

          WaitEnd.methods.send(
            () => {
              self.DetailModalGetSearchJobGovCode1();
            },
            () => {
              WaitEnd.methods.send(
                () => {
                  if (self.DetailModal.form.jobGovCode1 != "")
                    self.DetailModalGetSearchJobGovCode2(
                      self.DetailModal.form.jobGovCode1
                    );
                },
                () => {
                  WaitEnd.methods.send(
                    () => {
                      if (self.DetailModal.form.jobGovCode2 != "")
                        self.DetailModalGetSearchJobGovCode3(
                          self.DetailModal.form.jobGovCode2
                        );
                    },
                    () => {
                      if (self.DetailModal.form.jobGovCode3 != "")
                        self.DetailModalGetSearchJobGovCode4(
                          self.DetailModal.form.jobGovCode3
                        );
                    }
                  );
                }
              );
            }
          );
        }
      );
      self.DetailModal.dropDownList.syears =
        self.DetailModalGetSyearDropDownList();
      self.DetailModalGetOnJob();
    },
    //第二頁 取得基本資料內容
    B105_Detail: function () {
      const self = this;
      B105_Detail({ pkno: self.DetailModal.PreData.pkno }).then((rData) => {
        self.DetailModal.grid = rData.returnObject;
        self.DetailModal.form = {
          syear: String(self.DetailModal.grid.syear),
          govCode1: self.DetailModal.grid.goV_CODE_STR.split(",")[0],
          govCode2: self.DetailModal.grid.goV_CODE_STR.split(",")[1],
          govCode3: self.DetailModal.grid.goV_CODE_STR.split(",")[2],
          govCode4: self.DetailModal.grid.goV_CODE_STR.split(",")[3],
          jobGovCode1: self.DetailModal.grid.joB_GOV_CODE_STR.split(",")[0],
          jobGovCode2: self.DetailModal.grid.joB_GOV_CODE_STR.split(",")[1],
          jobGovCode3: self.DetailModal.grid.joB_GOV_CODE_STR.split(",")[2],
          jobGovCode4: self.DetailModal.grid.joB_GOV_CODE_STR.split(",")[3],
          idn: self.DetailModal.grid.idn,
          name: self.DetailModal.grid.name,
          title: self.DetailModal.grid.title,
          rank: self.DetailModal.grid.rank,
          tel: self.DetailModal.grid.tel,
          leave: self.DetailModal.grid.leave,
          arriveDate: self.DetailModal.grid.arrivE_DATE,
          leaveDate: self.DetailModal.grid.leavE_DATE,
          dtype: self.DetailModal.grid.dtype,
          sT_DATE: self.DetailModal.grid.sT_DATE,
          enD_DATE: self.DetailModal.grid.enD_DATE,
          sdate: self.DetailModal.grid.sdate,
          datetime: self.DetailModal.grid.datetime,
          lOVERDUE: self.DetailModal.grid.lOVERDUE == "Y" ? "Y" : "N",
          note: self.DetailModal.grid.note,
        };
        if (self.DetailModal.form.jobGovCode1 != "") self.Numm = 1; //基數歸1
        if (self.DetailModal.form.jobGovCode2 != "") self.Numm = 2; //基數歸2
        if (self.DetailModal.form.jobGovCode3 != "") self.Numm = 3; //基數歸3
        if (self.DetailModal.form.jobGovCode4 != "") self.Numm = 4; //基數歸4
      });
    },
    //第一頁刪
    B105_DetailEditSaveAlert: function () {
      const self = this;
      this.AlertSave.show = true;
      this.AlertSave.title = "提醒";
    },
    //第二頁 基本資料新增
    B105_DetailAddSave: function () {
      const self = this;
      let postData = {
        PKNO: 0,
        SYEAR: self.DetailModal.form.syear,
        JOB_GOV_CODE: self.DetailModal.form.jobGovCode4
          ? self.DetailModal.form.jobGovCode4
          : self.DetailModal.form.jobGovCode3
          ? self.DetailModal.form.jobGovCode3
          : self.DetailModal.form.jobGovCode2
          ? self.DetailModal.form.jobGovCode2
          : self.DetailModal.form.jobGovCode1
          ? self.DetailModal.form.jobGovCode1
          : "",
        JOB_GOV_CODE_STR:
          self.DetailModal.form.jobGovCode1 +
          "," +
          self.DetailModal.form.jobGovCode2 +
          "," +
          self.DetailModal.form.jobGovCode3 +
          "," +
          self.DetailModal.form.jobGovCode4,
        GOV_CODE: self.DetailModal.form.govCode4
          ? self.DetailModal.form.govCode4
          : self.DetailModal.form.govCode3
          ? self.DetailModal.form.govCode3
          : self.DetailModal.form.govCode2
          ? self.DetailModal.form.govCode2
          : self.DetailModal.form.govCode1
          ? self.DetailModal.form.govCode1
          : "",
        GOV_CODE_STR:
          self.DetailModal.form.govCode1 +
          "," +
          self.DetailModal.form.govCode2 +
          "," +
          self.DetailModal.form.govCode3 +
          "," +
          self.DetailModal.form.govCode4,
        IDN: self.DetailModal.form.idn,
        NAME: self.DetailModal.form.name,
        TITLE: self.DetailModal.form.title,
        RANK: self.DetailModal.form.rank,
        TEL: self.DetailModal.form.tel,
        LEAVE: self.DetailModal.form.leave,
        ARRIVE_DATE: self.DetailModal.form.arriveDate,
        LEAVE_DATE: self.DetailModal.form.leaveDate,
        DTYPE: self.DetailModal.form.dtype,
        ST_DATE: self.DetailModal.form.sT_DATE,
        END_DATE: self.DetailModal.form.enD_DATE,
        SDATE: self.DetailModal.form.sdate,
        DATETIME: self.DetailModal.form.datetime,
        lOVERDUE: self.DetailModal.form.lOVERDUE,
        NOTE: self.DetailModal.form.note,
        USERID: self.loginInfo ? self.loginInfo.id : "",
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "新增基本資料存檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      B105_DetailAddSave(postData).then((rData) => {
        console.log(rData);
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["存檔成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.doQuery();
            self.DetailModalBtnClear();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = [rData.messages[0]];
          //self.Alert.txt = "存檔失敗";
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁 基本資料修改
    B105_DetailEditSave: function () {
      const self = this;
      let postData = {
        PKNO: self.DetailModal.PreData.pkno,
        SYEAR: self.DetailModal.form.syear,
        JOB_GOV_CODE: self.DetailModal.form.jobGovCode4
          ? self.DetailModal.form.jobGovCode4
          : self.DetailModal.form.jobGovCode3
          ? self.DetailModal.form.jobGovCode3
          : self.DetailModal.form.jobGovCode2
          ? self.DetailModal.form.jobGovCode2
          : self.DetailModal.form.jobGovCode1
          ? self.DetailModal.form.jobGovCode1
          : "",
        JOB_GOV_CODE_STR:
          self.DetailModal.form.jobGovCode1 +
          "," +
          self.DetailModal.form.jobGovCode2 +
          "," +
          self.DetailModal.form.jobGovCode3 +
          "," +
          self.DetailModal.form.jobGovCode4,
        GOV_CODE: self.DetailModal.form.govCode4
          ? self.DetailModal.form.govCode4
          : self.DetailModal.form.govCode3
          ? self.DetailModal.form.govCode3
          : self.DetailModal.form.govCode2
          ? self.DetailModal.form.govCode2
          : self.DetailModal.form.govCode1
          ? self.DetailModal.form.govCode1
          : "",
        GOV_CODE_STR:
          self.DetailModal.form.govCode1 +
          "," +
          self.DetailModal.form.govCode2 +
          "," +
          self.DetailModal.form.govCode3 +
          "," +
          self.DetailModal.form.govCode4,
        IDN: self.DetailModal.form.idn,
        NAME: self.DetailModal.form.name,
        TITLE: self.DetailModal.form.title,
        RANK: self.DetailModal.form.rank,
        TEL: self.DetailModal.form.tel,
        LEAVE: self.DetailModal.form.leave,
        ARRIVE_DATE: self.DetailModal.form.arriveDate,
        LEAVE_DATE: self.DetailModal.form.leaveDate,
        DTYPE: self.DetailModal.form.dtype,
        ST_DATE: self.DetailModal.form.sT_DATE,
        END_DATE: self.DetailModal.form.enD_DATE,
        SDATE: self.DetailModal.form.sdate,
        DATETIME: self.DetailModal.form.datetime,
        lOVERDUE: self.DetailModal.form.lOVERDUE,
        NOTE: self.DetailModal.form.note,
        USERID: self.loginInfo ? self.loginInfo.id : "",
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "編輯基本資料存檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      B105_DetailEditSave(postData).then((rData) => {
        console.log(rData);
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["存檔成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.AlertSave.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.AlertSave.show = false;
          self.Alert.title = "錯誤";
          //self.Alert.txt = "存檔失敗";
          self.Alert.txt = [rData.messages[0]];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁 基本資料存檔
    DetailModalBtnSave: function () {
      const self = this;
      let errorMsg = [];
      //2022/2/11 修改時 反白元件不判斷
      if (self.DetailModal.ModifyType != "U") {
        if (self.DetailModal.form.idn.trim() == "") {
          errorMsg.push("請填寫身分證統一編號");
        } else if (!ChkIDorRCNumber(self.DetailModal.form.idn)) {
          errorMsg.push("身分證統一編號格式不對");
        }
        if (self.DetailModal.form.govCode1 == "") {
          errorMsg.push("請填寫受理申報機關");
        }
        if (self.DetailModal.form.jobGovCode1 == "") {
          errorMsg.push("請填寫服務機關");
        }
        if (self.DetailModal.form.name.trim() == "") {
          errorMsg.push("請填寫姓名");
        }
        if (self.DetailModal.form.title.trim() == "") {
          errorMsg.push("請填寫職稱");
        }
        if (self.DetailModal.form.tel.trim() == "") {
          errorMsg.push("請填寫聯絡電話");
        }
        if (self.DetailModal.form.leave == "") {
          errorMsg.push("請填寫現職狀況");
        } else {
          if (
              self.DetailModal.form.leave == "6" ||
              self.DetailModal.form.leave == "7" ||
              self.DetailModal.form.leave == "11" ||
              self.DetailModal.form.leave == "12" ||
              self.DetailModal.form.leave == "14" ||
              self.DetailModal.form.leave == "15" ||
              self.DetailModal.form.leave == "16" ||
              self.DetailModal.form.leave == "17"
            ) {
              if (self.DetailModal.form.leaveDate == "") {
                errorMsg.push("請填寫去職日");
              }
            }
        }
        if (self.DetailModal.form.arriveDate == "") {
          errorMsg.push("請填寫到職日");
        } else if (self.DetailModal.form.leaveDate != "") {
          if (
            self
              .$moment(self.DetailModal.form.leaveDate)
              .isBefore(self.DetailModal.form.arriveDate)
          ) {
            errorMsg.push("去職日需大於到職日");
          }
        }
        if (self.DetailModal.form.sT_DATE == "") {
          errorMsg.push("請填寫申報起始日");
        } else if (self.DetailModal.form.enD_DATE != "") {
          if (
            self
              .$moment(self.DetailModal.form.enD_DATE)
              .isBefore(self.DetailModal.form.sT_DATE)
          ) {
            errorMsg.push("申報結束日需大於申報起始日");
          }
        } else if (self.DetailModal.form.sdate != "") {
          if (
            self
              .$moment(self.DetailModal.form.datetime)
              .isBefore(self.DetailModal.form.sT_DATE)
          ) {
            errorMsg.push("上傳日需大於申報起始日");
          }
        }
      }
      else{
        if (self.DetailModal.form.leave == "") {
          errorMsg.push("請填寫現職狀況");
        } else {
          if (
              self.DetailModal.form.leave == "6" ||
              self.DetailModal.form.leave == "7" ||
              self.DetailModal.form.leave == "11" ||
              self.DetailModal.form.leave == "12" ||
              self.DetailModal.form.leave == "14" ||
              self.DetailModal.form.leave == "15" ||
              self.DetailModal.form.leave == "16" ||
              self.DetailModal.form.leave == "17"
            ) {
              if (self.DetailModal.form.leaveDate == "") {
                errorMsg.push("請填寫去職日");
              }
            }
        }
      }
      if (self.DetailModal.form.dtype == "") {
        errorMsg.push("請填寫申報種類");
      }
      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        self.AlertSave.show = false;
        return false;
      }
      switch (self.DetailModal.ModifyType) {
        case "I":
          self.B105_DetailAddSave();
          break;
        case "U":
          self.B105_DetailEditSave();
          break;
      }
    },
    //第二頁 基本資料重填
    DetailModalBtnClear: function () {
      const self = this;
      self.DetailModal.form = {
        syear: String(new Date().getFullYear() - 1911),
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        idn: "",
        name: "",
        title: "",
        rank: "",
        tel: "",
        leave: "",
        arriveDate: "",
        leaveDate: "",
        dtype: "",
        sT_DATE: "",
        enD_DATE: "",
        sdate: "",
        lOVERDUE: "N",
        note: "",
      };
      self.JobGovCodeInit(self.DetailModal.form);
      self.GovCodeInit(self.DetailModal.form);
      self.DetailModalGetSearchJobGovCode1();
      self.DetailModalGetSearchGovCode1();
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //A101明細
    btnA101Detail: function (data) {
      const self = this;
      self.A101DetailModal.form = {
        //取得Radmin_Rel內
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        idn: "",
        name: "",
        birthday: "",
        title: "",
        rank: "",
        tel: "",
        email: "",
        arriveDate: "",
        leaveDate: "",
        //現職狀況
        leave: "",
        //應申報身分資格
        status: "",
        //備註
        leave_Reason: "",
      };
      self.A101DetailModal.PreData = data;
      self.getA101DetailData(data);

      self.A101DetailModal.modifyType = "U";
      self.A101DetailModal.title = "A101申報人基本資料維護-明細";
      self.A101DetailModal.show = true;
    },
    //A101明細 API
    getA101DetailData: function (data) {
      const self = this;
      A101_DetailInit({ idn: data.idn, goV_CODE: data.goV_CODE }).then(
        (rData) => {
          if (rData.result) {
            self.A101DetailModal.grid = rData.returnObject;
            self.A101DetailModal.form = {
              //取得Radmin_Rel內
              govCode1: self.A101DetailModal.grid.govCodeStr.split(",")[0],
              govCode2: self.A101DetailModal.grid.govCodeStr.split(",")[1],
              govCode3: self.A101DetailModal.grid.govCodeStr.split(",")[2],
              govCode4: self.A101DetailModal.grid.govCodeStr.split(",")[3],
              jobGovCode1:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[0],
              jobGovCode2:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[1],
              jobGovCode3:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[2],
              jobGovCode4:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[3],
              idn: self.A101DetailModal.grid.idn,
              name: self.A101DetailModal.grid.name,
              birthday: self.A101DetailModal.grid.birthday,
              title: self.A101DetailModal.grid.title,
              rank: self.A101DetailModal.grid.rank,
              tel: self.A101DetailModal.grid.tel,
              email: self.A101DetailModal.grid.email,
              arriveDate: self.A101DetailModal.grid.arriveDate,
              leaveDate: self.A101DetailModal.grid.leaveDate,
              //現職狀況
              leave: self.A101DetailModal.grid.leave,
              //應申報身分資格
              status: self.A101DetailModal.grid.status,
              //備註
              leave_Reason: self.A101DetailModal.grid.leaveReason,
            };
          } else {
            self.A101DetailModal.show = false;

            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = [
              "未取得資料，請至A101確認此[身分證統一編號][受理申報機關]是否有資料",
            ];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
          self.A101DetailModalInit();
        }
      );
    },
    A101DetailModalInit: function () {
      const self = this;
      self.modalGetA101SearchGovCode1();
      self.modalGetA101SearchGovCode2();
      self.modalGetA101SearchGovCode3();
      self.modalGetA101SearchGovCode4();
      self.modalGetA101OnDeclare();
      self.modalGetA101OnJob();
    },
    //A101明細取得服務機關第一層類別 DetailModal
    modalGetA101SearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.A101DetailModal.dropDownList.govCode1s = rData.returnObject;
        self.A101DetailModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //A101明細取得服務機關第二層類別 DetailModal
    modalGetA101SearchGovCode2: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode1 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode1,
          LAYER_NUM: "2",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode2s = rData.returnObject;
          self.A101DetailModal.form.govCode2 =
            self.A101DetailModal.form.govCode2;
        });
      }
      if (self.A101DetailModal.form.jobGovCode1 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode1,
          LAYER_NUM: "2",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode2s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode2 =
            self.A101DetailModal.form.jobGovCode2;
        });
      }
    },
    //A101明細取得服務機關第三層類別 DetailModal
    modalGetA101SearchGovCode3: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode2 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode2,
          LAYER_NUM: "3",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode3s = rData.returnObject;
          self.A101DetailModal.form.govCode3 =
            self.A101DetailModal.form.govCode3;
        });
      }
      if (self.A101DetailModal.form.jobGovCode2 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode2,
          LAYER_NUM: "3",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode3s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode3 =
            self.A101DetailModal.form.jobGovCode3;
        });
      }
    },
    //A101明細取得服務機關第四層類別 DetailModal
    modalGetA101SearchGovCode4: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode3 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode3,
          LAYER_NUM: "4",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode4s = rData.returnObject;
          self.A101DetailModal.form.govCode4 =
            self.A101DetailModal.form.govCode4;
        });
      }
      if (self.A101DetailModal.form.jobGovCode3 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode3,
          LAYER_NUM: "4",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode4s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode4 =
            self.A101DetailModal.form.jobGovCode4;
        });
      }
    },
    //A101取得申報身分資格 DetailModal
    modalGetA101OnDeclare: function () {
      const self = this;
      SearchGridOnDeclare({}).then((rData) => {
        self.A101DetailModal.dropDownList.OnDeclare = [
          { mcode: "", mvalue: "" },
        ].concat(rData.returnObject);
      });
    },
    //A101取得在職狀態 GovCodeModal
    modalGetA101OnJob: function () {
      const self = this;
      SearchGridOnJob({}).then((rData) => {
        self.A101DetailModal.dropDownList.onJobs = [
          { value: "", text: "" },
        ].concat(rData.returnObject);
      });
    },
    GovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.govCode1 = self.SessionGovCode;
        form.govCode2 = "";
        form.govCode3 = "";
        form.govCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.govCode1 = govCodeArray[0];
          form.govCode2 = govCodeArray[1];
          form.govCode3 = govCodeArray[2];
          form.govCode4 = govCodeArray[3];
        }
      }
    },
    GovCode1Change: function () {
      const self = this;
      self.form.govCode2 = "";
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode2s = [];
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode2Change: function () {
      const self = this;
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode3Change: function () {
      const self = this;
      self.form.govCode4 = "";
      self.dropDownList.govCode4s = [];
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    DetailModalGovCode1Change: function () {
      const self = this;
      self.DetailModal.form.govCode2 = "";
      self.DetailModal.form.govCode3 = "";
      self.DetailModal.form.govCode4 = "";
      self.DetailModal.dropDownList.govCode2s = [];
      self.DetailModal.dropDownList.govCode3s = [];
      self.DetailModal.dropDownList.govCode4s = [];
    },
    DetailModalGovCode2Change: function () {
      const self = this;
      self.DetailModal.form.govCode3 = "";
      self.DetailModal.form.govCode4 = "";
      self.DetailModal.dropDownList.govCode3s = [];
      self.DetailModal.dropDownList.govCode4s = [];
    },
    DetailModalGovCode3Change: function () {
      const self = this;
      self.DetailModal.form.govCode4 = "";
      self.DetailModal.dropDownList.govCode4s = [];
    },
    DetailModalJobGovCode1Change: function () {
      const self = this;
      self.DetailModal.form.jobGovCode2 = "";
      self.DetailModal.form.jobGovCode3 = "";
      self.DetailModal.form.jobGovCode4 = "";
      self.DetailModal.dropDownList.jobGovCode2s = [];
      self.DetailModal.dropDownList.jobGovCode3s = [];
      self.DetailModal.dropDownList.jobGovCode4s = [];
    },
    DetailModalJobGovCode2Change: function () {
      const self = this;
      self.DetailModal.form.jobGovCode3 = "";
      self.DetailModal.form.jobGovCode4 = "";
      self.DetailModal.dropDownList.jobGovCode3s = [];
      self.DetailModal.dropDownList.jobGovCode4s = [];
    },
    DetailModalJobGovCode3Change: function () {
      const self = this;
      self.DetailModal.form.jobGovCode4 = "";
      self.DetailModal.dropDownList.jobGovCode4s = [];
    },
    GetSearchRGovCode: function (newValue, num) {
      const self = this;
      if (self.Numm <= num && newValue != "") {
        self.Numm = num;

        let GovCode = { GOV_CODE: newValue };
        SearchRGovCode(GovCode).then((rData) => {
          if (rData.returnObject.length > 0) {
            self.DetailModal.form.govCode1 =
              rData.returnObject[0].rGovCodeStr.split(",")[0];
            self.DetailModal.form.govCode2 =
              rData.returnObject[0].rGovCodeStr.split(",")[1];
            self.DetailModal.form.govCode3 =
              rData.returnObject[0].rGovCodeStr.split(",")[2];
            self.DetailModal.form.govCode4 =
              rData.returnObject[0].rGovCodeStr.split(",")[3];
          } else if (newValue != "") {
            self.DetailModal.form.govCode1 = "";
            self.DetailModal.form.govCode2 = "";
            self.DetailModal.form.govCode3 = "";
            self.DetailModal.form.govCode4 = "";

            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["此服務機關未有受理申報機構，請洽政風人員確認"];
            //self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      const self = this;
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode2(newValue);
    },
    "form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode3(newValue);
    },
    "form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "DetailModal.form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.DetailModalGetSearchGovCode2(newValue);
    },
    "DetailModal.form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.DetailModalGetSearchGovCode3(newValue);
    },
    "DetailModal.form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.DetailModalGetSearchGovCode4(newValue);
    },
    "DetailModal.form.govCode4": function (newValue, oldValue) {
      const self = this;
      self.DetailModal.form.govCode4 = newValue;
      if (newValue != "" && newValue != undefined) {
        self.GetSearchRGovCode(newValue, 4);
      }
    },
    "DetailModal.form.jobGovCode1": function (newValue, oldValue) {
      const self = this;
      self.DetailModal.form.govCode1 = newValue;
      if (newValue != "" && newValue != undefined) {
        this.DetailModalGetSearchJobGovCode2(newValue);
          self.GetSearchRGovCode(newValue, 1);
      }
    },
    "DetailModal.form.jobGovCode2": function (newValue, oldValue) {
      const self = this;
      self.DetailModal.form.govCode2 = newValue;
      if (newValue != "" && newValue != undefined) {
        this.DetailModalGetSearchJobGovCode3(newValue);
          self.GetSearchRGovCode(newValue, 2);
      }
    },
    "DetailModal.form.jobGovCode3": function (newValue, oldValue) {
      const self = this;
      self.DetailModal.form.govCode3 = newValue;
      if (newValue != "" && newValue != undefined) {
        this.DetailModalGetSearchJobGovCode4(newValue);
          self.GetSearchRGovCode(newValue, 3);
      }
    },
    "DetailModal.form.jobGovCode4": function (newValue, oldValue) {
      const self = this;
      self.DetailModal.form.govCode3 = newValue;
      if (newValue != "" && newValue != undefined) {
          self.GetSearchRGovCode(newValue, 4);
      }
    },
    "DetailModal.form.idn": function (newValue, oldValue) {
      const self = this;
      if (newValue != oldValue) {
        self.DetailModal.form.idn = newValue.toUpperCase();
      }
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.GovCodeInit(self.form);
    self.JobGovCodeInit(self.form);
    self.getSearchGovCode1();
    self.getSearchJobGovCode1();
    self.dropDownList.syears = self.getSyearDropDownList();
    self.doQuery();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
